import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  bgcolor: 'grey.50',
  borderRadius: 1,
};

export const header: SxStyle = {
  alignItems: 'center',
  textAlign: 'center',
  pt: 3,
};
